import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonUa from './locales/ua/common.json';
import profileUa from './locales/ua/profile.json';
import gameUa from './locales/ua/game.json';
import commonRu from './locales/ru/common.json';
import profileRu from './locales/ru/profile.json';
import gameRu from './locales/ru/game.json';
import dashboardRu from './locales/ru/dashboard.json';
import commonEn from './locales/en/common.json';
import profileEn from './locales/en/profile.json';
import gameEn from './locales/en/game.json';
import dashboardEn from './locales/en/dashboard.json';
import dashboardUa from './locales/ua/dashboard.json';

i18n.use(initReactI18next).init({
  resources: {
    ua: {
      common: commonUa,
      profile: profileUa,
      game: gameUa,
      dashboard: dashboardUa,
    },
    ru: {
      common: commonRu,
      profile: profileRu,
      game: gameRu,
      dashboard: dashboardRu,
    },
    en: {
      common: commonEn,
      profile: profileEn,
      game: gameEn,
      dashboard: dashboardEn,
    },
  },
  supportedLngs: ['ua', 'ru', 'en'],
  lng: 'ua',
  fallbackLng: 'ua',
  ns: ['common', 'profile', 'game', 'dashboard'],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
